import { z } from 'zod';
export const BACKTEST_PERIODS = ['overall', 'training', 'walkForward'];
export const backtestPeriodSchema = z.enum(BACKTEST_PERIODS);
export const strategyVariantBacktestMetricsSchema = z.object({
    completedBacktestCount: z.number(),
    totalTrades: z.number(),
    netProfit: z.number().nullable(),
    totalRiskCapital: z.number().nullable(),
    avgReturnPercent: z.number().nullable(),
    avgReturnOnRiskCapitalPercent: z.number().nullable(),
    avgMaxDrawdownPercent: z.number().nullable(),
    avgWinRate: z.number().nullable(),
    avgSharpeRatio: z.number().nullable(),
    profitFactor: z.number().nullable(),
    avgPainIndex: z.number().nullable()
});
export const strategyVariantPeriodSummarySchema = z.object({
    metrics: strategyVariantBacktestMetricsSchema.nullable(),
    backtestCount: z.number(),
    summarizedBacktestCount: z.number(),
    incompleteTradeCount: z.number(),
    outOfWindowTradeCount: z.number(),
    missingCloseTradeCount: z.number(),
    windowStartDateTime: z.string().nullable(),
    windowEndDateTime: z.string().nullable(),
    trainingEndDateTimeMin: z.string().nullable(),
    trainingEndDateTimeMax: z.string().nullable(),
    fallbackCutoffCount: z.number()
});
export const strategyVariantPeriodsSchema = z.object({
    overall: strategyVariantPeriodSummarySchema,
    training: strategyVariantPeriodSummarySchema,
    walkForward: strategyVariantPeriodSummarySchema
});
// Saved queue handles freeze both populated results and completed-empty/pending evaluations.
export const strategyVariantSavedCohortSchema = z.object({
    strategyId: z.number().int().positive(),
    jobIds: z.array(z.number().int().positive()).min(1).max(5000)
});
export const strategyVariantSavedCohortSummarySchema = strategyVariantSavedCohortSchema.extend({
    resultBacktestIds: z.array(z.number().int().positive()),
    completedEmptyJobIds: z.array(z.number().int().positive()),
    pendingJobIds: z.array(z.number().int().positive()),
    failedJobIds: z.array(z.number().int().positive()),
    sourceExperimentIds: z.array(z.number().int().positive()),
    sourceBestBacktestIds: z.array(z.number().int().positive()),
    sourceScreenerOptimizerConfirmationIds: z.array(z.number().int().positive()),
    restrictedJobCount: z.number().int().nonnegative(),
    configurationCount: z.number().int().nonnegative(),
    strategyVersionKey: z.string(),
    startDateTime: z.string(),
    endDateTime: z.string(),
    optionBuyingStrategyIds: z.array(z.number().int().positive().nullable()).length(6),
    exitCandidateId: z.number().int().positive().nullable(),
    exitCandidateHash: z.string().nullable(),
    exitFingerprint: z.string().nullable(),
    regimeReleaseId: z.number().int().positive().nullable(),
    tradeLogicV2EntryVersionId: z.number().int().positive().nullable(),
    entryScorecardId: z.number().int().positive().nullable(),
    entryScorecardVersionKey: z.string().nullable(),
    entryScreenerRuleIdApplied: z.number().int().positive().nullable(),
    entryScreenerRuleContentHashApplied: z.string().nullable(),
    entryAllowedDatesHashes: z.array(z.string()),
    entryAllowedEntriesHashes: z.array(z.string())
});
//# sourceMappingURL=BacktestPeriodTypes.js.map